import React from 'react';
import { styled } from '@compiled/react';
import InfoIcon from '@atlaskit/icon/core/status-information';
import WarningIcon from '@atlaskit/icon/core/status-warning';
import { token } from '@atlaskit/tokens';

export type BannerType = 'info' | 'warning';
export type Props = {
	bannerMessage: React.ReactNode;
	type: BannerType;
};

export const ColumnPickerBannerMessage = ({ bannerMessage, type }: Props) => (
	<BannerContent type={type}>
		{type === 'warning' ? (
			<WarningIcon spacing="spacious" label="" color="currentColor" />
		) : (
			<InfoIcon spacing="spacious" label="" color="currentColor" />
		)}
		<BannerMessage>{bannerMessage}</BannerMessage>
	</BannerContent>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const BannerContent = styled.div<{ type?: 'info' | 'warning' }>({
	display: 'flex',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
	backgroundColor: (props) =>
		props.type === 'warning'
			? token('color.background.warning')
			: token('color.background.information'),
	paddingTop: token('space.100'),
	paddingRight: token('space.100'),
	paddingBottom: token('space.100'),
	paddingLeft: token('space.100'),

	color: token('color.text.subtle'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const BannerMessage = styled.p({
	marginTop: 0,
	marginRight: 0,
	marginBottom: 0,
	marginLeft: token('space.100'),
	font: token('font.body.small'),
});
